import React from "react";
import styled, { css } from "styled-components";
import { TabSheet } from "../../../components/tabLayout";
import { AccountSummary } from "./accountSummary";

const TabTitle = styled.span(({ theme }) => css`
  .desktop {
    display: none;

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      display: inline;
    }
  }
`);

export const ManageRepaymentSheet = ({ accountNumber }) => (
  <TabSheet id={accountNumber} title={() => (
    <TabTitle><span className="desktop">Loan ID: </span>{accountNumber}</TabTitle>
  )}>
    <AccountSummary accountNumber={accountNumber}/>
  </TabSheet>
);